import request from "@/utils/request";
// 消息
export function userChatApi(data) {
  return request({
    url: "user/chat/index",
    method: "get",
    params: data,
  });
}


export function accountToTencentApi(data) {
  return request({
    url: "chatgroup/accountToTencent",
    method: "get",
    params: data,
  });
}
export function getGroupStatusApi(data) {
  return request({
    url: "chatgroup/group/getGroupStatus",
    method: "get",
    params: data,
  });
}
export function getConversationProfileApi(data) {
  return request({
    url: "chatgroup/friend/getConversationProfile",
    method: "get",
    params: data,
  });
}


export function chatUserInfoApi(data) {
  return request({
    url: "chatgroup/group/chatUserInfo",
    method: "post",
    data,
  });
}
export function getUsersCardApi(data) {
  return request({
    url: "chatgroup/getUsersCard",
    method: "post",
    data,
  });
}

export function createDoApi(data) {
  return request({
    url: "chatgroup/friend/createDo",
    method: "post",
    data,
  });
}
export function updateFriendProfileApi(data) {
  return request({
    url: "chatgroup/friend/updateFriendProfile",
    method: "post",
    data,
  });
}
// 群成员
export function memberJoListApi(data) {
  return request({
    url: "chatgroup/group/memberJoList",
    method: "post",
    data,
  });
}
// 获取回复列表
export function replytemplateListApi(data) {
  return request({
    url: "manage/reply/templateList",
    method: "get",
    params: data,
  });
}
// 分组
export function replycategoryListApi(data) {
  return request({
    url: "manage/reply/categoryList",
    method: "get",
    params: data,
  });
}
// 通讯录
export function getfriendListApi(data) {
  return request({
    url: "chatgroup/friend/list",
    method: "get",
    params: data,
  });
}
// 群
export function getgroupListApi(data) {
  return request({
    url: "chatgroup/group/list",
    method: "get",
    params: data,
  });
}
// 加好友数量信息
export function getApplyFriendListApi(data) {
  return request({
    url: "chatgroup/friend/getApplyFriendList",
    method: "get",
    params: data,
  });
}
// 好友信息
export function getFriendInfoApi(data) {
  return request({
    url: "chatgroup/getFriendInfo",
    method: "get",
    params: data,
  });
}
// 好友信息
export function checkUserApi(data) {
  return request({
    url: "chatgroup/checkUser",
    method: "get",
    params: data,
  });
}
// 票券列表
export function ticketListApi(data) {
  return request({
    url: "chatgroup/group/ticketList",
    method: "get",
    params: data,
  });
}
// 课程列表
export function chatGroupCourseListApi(data) {
  return request({
    url: "educate/course/chatGroupCourseList",
    method: "get",
    params: data,
  });
}
// 商品列表
export function chatGroupGoodsListApi(data) {
  return request({
    url: "chatgroup/group/goodsList",
    method: "get",
    params: data,
  });
}
// 视频列表
export function chatGroupVideoListApi(data) {
  return request({
    url: "chatgroup/group/video/list",
    method: "get",
    params: data,
  });
}
// 搜索商品列表
export function shopProductListApi(data) {
  return request({
    url: "shop/product/list",
    method: "get",
    params: data,
  });
}
// 标签列表
export function labelIndexApi(data) {
  return request({
    url: "chatgroup/labelIndex",
    method: "get",
    params: data,
  });
}
// 添加商品
export function addChatGroupProductApi(data) {
  return request({
    url: "chatgroup/group/addChatGroupProduct",
    method: "post",
    data,
  });
}
// 解散圈子
export function destroyGroupApi(data) {
  return request({
    url: "chatgroup/group/destroyGroup",
    method: "post",
    data,
  });
}
// 删除标签
export function deleteLabelApi(data) {
  return request({
    url: "chatgroup/label/delete",
    method: "post",
    data,
  });
}
// 同意添加好友
export function friendAgreeDoApi(data) {
  return request({
    url: "chatgroup/friend/agreeDo",
    method: "post",
    data,
  });
}
// 拒绝添加好友
export function friendRefuseDoApi(data) {
  return request({
    url: "chatgroup/friend/refuseDo",
    method: "post",
    data,
  });
}
// 选择标签
export function LabelpushMemberrApi(data) {
  return request({
    url: "chatgroup/label/pushMember",
    method: "post",
    data,
  });
}
// 删除商品
export function delChatGroupProductApi(data) {
  return request({
    url: "chatgroup/group/delChatGroupProduct",
    method: "post",
    data,
  });
}
// 删除商品
export function updateProductSortApi(data) {
  return request({
    url: "chatgroup/group/updateProductSort",
    method: "post",
    data,
  });
}

// 群课程排序
export function updateCourseSortApi(data) {
  return request({
    url: "educate/course/updateCourseSort",
    method: "post",
    data,
  });
}
// 添加群课程视频
export function groupVideosaveApi(data) {
  return request({
    url: "chatgroup/group/video/save",
    method: "post",
    data,
  });
}
// 删除群课程
export function delChatGroupCourseApi(data) {
  return request({
    url: "educate/course/delChatGroupCourse",
    method: "post",
    data,
  });
}
// 更新群视频
export function delChatGroupVideoUpdateApi(data) {
  return request({
    url: "chatgroup/group/video/update",
    method: "post",
    data,
  });
}
// 删除群视频
export function delChatGroupVideoApi(data) {
  return request({
    url: "chatgroup/group/video/delete/" + data.id,
    method: "delete", 
    data,
  });
}
// 搜索群
export function groupIndexApi(data) {
  return request({
    url: "chatgroup/group/groupIndex",
    method: "post",
    data,
  });
}
// 删除票种
export function ticketDelApi(data) {
  return request({
    url: "chatgroup/group/ticketDel",
    method: "delete",
    data,
  });
}
// 加好友群信息
export function getchatgroupDetailApi(data) {
  return request({
    url: "chatgroup/group/chatDetail/" + data.groupID,
    method: "get",
  });
}
// 群二维码
export function shareCodeApi(data) {
  return request({
    url: "chatgroup/group/shareCode/" + data.groupID,
    method: "get",
  });
}
// 群资料
export function groupDetailApi(data) {
  return request({
    url: "chatgroup/group/detail/" + data.groupID,
    method: "get",
  });
}
// 群分享赚
export function setShareProfitApi(data) {
  return request({
    url: "chatgroup/group/setShareProfit",
    method: "get",
    params: data,
  });
}
// 标签列表
export function labelListApi(data) {
  return request({
    url: "chatgroup/group/createIndex",
    method: "get",
    params: data,
  });
}
// 保存分享赚
export function setShareProfitDoApi(data) {
  return request({
    url: "chatgroup/group/setShareProfitDo",
    method: "post",
    data,
  });
}
// 群设置
export function groupUpdateApi(data) {
  return request({
    url: "chatgroup/group/update",
    method: "post",
    data,
  });
}
// 添加票种
export function ticketSaveApi(data) {
  return request({
    url: "chatgroup/group/ticketSaveV240509",
    method: "post",
    data,
  });
}
// 同意加群
export function entryAuditApi(data) {
  return request({
    url: "chatgroup/group/entryAudit",
    method: "post",
    data,
  });
}
// 同意加群
export function entryRefuseApi(data) {
  return request({
    url: "chatgroup/group/entryRefuse",
    method: "post",
    data,
  });
}
// 待审核人数
export function groupauditListApi(data) {
  return request({
    url: "chatgroup/group/auditList",
    method: "post",
    data,
  });
}
// 退圈
export function memberUpdateApi(data) {
  return request({
    url: "chatgroup/group/memberUpdate",
    method: "post",
    data,
  });
}

// 添加分类
export function replycategoryApi(data) {
  return request({
    url: "manage/reply/category",
    method: "post",
    data,
  });
}

// 添加模板
export function createTemplatesApi(data) {
  return request({
    url: "manage/reply/createTemplates",
    method: "post",
    data,
  });
}
// 修改模板
export function updateTemplateApi(data) {
  return request({
    url: "manage/reply/updateTemplate",
    method: "post",
    data,
  });
}

// 删除模板
export function delTemplateApi(data) {
  return request({
    url: "manage/reply/delTemplate",
    method: "post",
    data,
  });
}
// 删除分类
export function delCategoryApi(data) {
  return request({
    url: "manage/reply/delCategory",
    method: "post",
    data,
  });
}
// 编辑分类
export function updateCategoryApi(data) {
  return request({
    url: "manage/reply/updateCategory",
    method: "post",
    data,
  });
}
// 公告内瓤
export function noticeInfoByUserApi(data) {
  return request({
    url: "chatgroup/group/noticeInfoByUser",
    method: "post",
    data,
  });
}


